<template>
    <b-modal @hidden="cancelar" v-model="show" size="l" button-size="sm" hide-footer :title="prefix + title">

        <b-card no-body>
            <b-card-body>
                <b-card bg-variant="light">
                    <b-form-row @submit.prevent="salvarTipoDeManutencao">

                        <lg-form-date invalidFeedback="A data de deve ser informada!" description=" "
                            v-model="form.data" label="Data:*" cols="12" sm="12" />


                        <LgFinderPageTipoManutencaoIBP label="Tipo de Manutenção:*" :value="form.tipoManutencao"
                            @input="tipoManutencaoIbpSelect" :prefix="prefix + title + ' > '">
                        </LgFinderPageTipoManutencaoIBP>


                        <lg-finder-page-pessoa id="finderPessoaTMIBPC" label="Responsável:*"
                            :prefix="prefix + title + ' > '" title="Responsáveis" v-model="form.responsavel"
                            invalidFeedback="Informe um responsável!" @onselect="handlePessoaSelect" />

                        <b-form-group label="Observações:" label-for="observacaoTMC">
                            <textarea v-model="form.observacao" class="form-control" id="observacaoTMC"
                                rows="2"></textarea>

                        </b-form-group>
                    </b-form-row>

                    <b-form-row>
                        <b-col cols="12" class="text-right">


                        </b-col>
                    </b-form-row>

                </b-card>
                <b-card bg-variant="light">
                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvar" class=" my-2" size="sm" pill variant="success" @click="salvarTipoDeManutencao">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvar" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelar" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelar" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>

                </b-card>
            </b-card-body>
        </b-card>
    </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import { FormResourceMixin } from "@/core/mixins/resource";

import LgFinderPageTipoManutencaoIBP from "@/components/Finders/LgFinderPageTipoManutencaoIBP.vue"
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";

export default {

    name: "TipoDeManutencaoCadastroList",

    components: {
        LgFinderPagePessoa,
        LgFinderPageTipoManutencaoIBP,
        LgFormDate,
    },

    props: {
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Cadastro"
        },

        id: String,
        onsave: Function,
        solicitacaoManutencaoId: Number,
        value: Object,
    },

    data() {
        return {
            show: true,
            modalTipoManutencaoIbpId: "modalTipoManutencaoIbpId",
            form: {
                data: "",
                tipoManutencao: {},
                responsavel: {},
                observacao: "",
                solicitacaoManutencao: {
                    id: this.solicitacaoManutencaoId,
                }
            },
        }
    },
    mixins: [ListResourceMixin, FormResourceMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/manutencaoitembempermanente`)
    },
    computed: {
        actionsBtn() {
            return [
                {
                    acao: this.$editResource,
                    label: "Editar",
                    icon: "pencil-square",
                    type: "function",
                },
                {
                    acao: this.$removeResource,
                    label: "Deletar",
                    icon: "trash",
                    type: "function",
                },
            ]
        },
    },
    methods: {

        async tipoDeManutencaoCadastroSelect(item) {
            this.$emit("onselect", item)
        },


        async tipoManutencaoIbpSelect(item) {

            this.form.tipoManutencao = item;
        },

        handlePessoaSelect(item) {
            this.form.responsavel = item;
        },

        async salvarTipoDeManutencao() {

            try {

                if (!this.form.data || this.form.data == "") {

                    this.$notify({
                        type: "danger",
                        message: "Selecione uma data",
                    });
                    return;
                }


                if (!this.form.tipoManutencao || !this.form.tipoManutencao.id) {

                    this.$notify({
                        type: "danger",
                        message: "Selecione um tipo de manutenção",
                    });
                    return;
                }

                if (!this.form.responsavel || !this.form.responsavel.id) {

                    this.$notify({
                        type: "danger",
                        message: "Selecione um responsável",
                    });
                    return;
                }


                await this.$saveResource(this.form, "", false, {}, false);
            }
            catch (error) {
                console.log(error)
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
            this.cancelar();

        },

        cancelar() {
            this.$emit("close");
        },

        async showModalTipoManutencaoIbp() {
            this.$bvModal.show(this.modalTipoManutencaoIbpId)
        },


    },
}
</script>
